module.exports = __webpack_public_path__ + "img/wahts.cc7ed41a.png";